import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NewVsReturningData } from '../../shared/types';
import { MobileDetectionMixin } from '../../shared/mixins/mobile-detection.mixin';

@Component({
  selector: 'app-new-vs-returning-card',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './new-vs-returning-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./new-vs-returning-card.component.scss'],
})
export class NewVsReturningCardComponent extends MobileDetectionMixin {
  @Input() data!: NewVsReturningData;
}
